export enum Attendance {
  Attending = 'attending',
  Declined = 'declined',
  DeclinedSilently = 'declinedSilently',
  Maybe = 'maybe',
  Interested = 'interested',
  NoReply = 'noReply',
}
